import { interactableHeight } from '@cbhq/cds-common/tokens/interactableHeight';
import { Fallback } from '@cbhq/cds-web/layout/Fallback';

export function ProfileDropdownFallback() {
  const size = interactableHeight.compact;
  return <Fallback width={size} height={size} shape="circle" />;
}
